import React from 'react';
import { FormField } from 'taboola-ultimate-ui';
import { OutlineEditableText } from 'modules/campaigns/components/OutlineEditableText/OutlineEditableText';
import { withIndication } from 'modules/errors';
import { FormattedMessage, useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import { useFormValidatedValue, validationFunctions } from 'modules/taboola-common-frontend-modules/validations';
import styles from './subscriptionNameField.module.scss';

const OutlineEditableTextWithIndication = withIndication(OutlineEditableText);
const validations = [
    {
        validationFn: validationFunctions.isNotEmptyString,
        messageId: 'push-api.subscription.validations.error.name.empty',
        defaultMessage: 'Please enter a Subscription Name',
    },
    {
        validationFn: validationFunctions.isLength,
        options: { min: 1, max: 10 },
        messageId: 'push-api.subscription.validations.error.name.length',
        defaultMessage: 'Subscription Name must be between {min} and {max} characters',
    },
];

export const SubscriptionNameField = () => {
    const {
        value: name,
        onChange: onNameChange,
        indicationData,
    } = useFormValidatedValue({
        field: 'name',
        validations,
    });

    const { formatMessage } = useIntl();
    const placeholder = formatMessage({
        id: `push-api.subscription.name.placeholder`,
        defaultMessage: 'Type name here...',
    });

    return (
        <FormField
            inputId="subscription-name-input"
            containerClass={styles['input-container']}
            label={<FormattedMessage id="push-api.subscription.name.title" defaultMessage="Name" />}
        >
            <OutlineEditableTextWithIndication
                id="name"
                value={name}
                onChange={onNameChange}
                placeholder={placeholder}
                {...indicationData}
            />
        </FormField>
    );
};
